import { Body, Heading, Icon } from '@assembly-js/design-system';
import { useTranslation } from 'react-i18next';

import { useElectronUpdateStatus } from 'src/features/electron/ElectronUpdateContext';
import { getElectronAPI } from 'src/hooks/useElectron';
import { useTrackAppVersion } from 'src/hooks/useTrackAppVersion';

export function SidebarUpdateCard() {
  const { t } = useTranslation();
  const { status } = useElectronUpdateStatus();
  const api = getElectronAPI();
  const { hasNewVersion } = useTrackAppVersion();

  const isElectronUpdate = api && status === 'ready';
  const isWebUpdate = !api && hasNewVersion;

  if (!isElectronUpdate && !isWebUpdate) {
    return null;
  }

  const handleClick = () => {
    if (isElectronUpdate) {
      api.installUpdate();
    } else {
      window.location.reload();
    }
  };

  return (
    <button
      type="button"
      className="mb-3 w-full appearance-none hover:cursor-pointer bg-white border border-solid border-gray-200 outline-none shadow-none rounded-lg p-2 py-1.5 flex flex-row items-center gap-2"
      onClick={handleClick}
    >
      <div className="flex items-center justify-center rounded-md bg-gray-100 p-1.5">
        <Icon icon="Repeat" className="h-4 w-4" />
      </div>
      <div className="flex flex-col w-full items-start">
        <Heading size="xs" className="text-black-heading">
          {t(($) => $.desktop_app.update_toast.title)}
        </Heading>
        <Body className="text-secondary text-[10px]">
          {isWebUpdate
            ? t(($) => $.desktop_app.update_toast.web_description)
            : t(($) => $.desktop_app.update_toast.description)}
        </Body>
      </div>
    </button>
  );
}
